import React, { Component } from "react";
import Avatar from "../assets/images/avatar.jpg";
import firebase from "../config/firebaseInit";
import AvatarStore from "../store/avatar_store";

class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = { showWarning: false, photoURL: Avatar, displayName: "", email: "", phoneNumber: "" }
        this.connectUser = this.connectUser.bind(this);
        this.SingOut = this.SingOut.bind(this);
    }
    SingOut(e) {
        console.log("DECONNEXION");
        firebase.auth().signOut().then(() => {
            console.log("Vous êtes deconnecté");
            this.setState({
                photoURL: Avatar,
                showWarning: false,
                displayName: "",
                email: "",
                phoneNumber: ""
            })
        })
        AvatarStore.setPathImage(Avatar);

    }
    componentDidMount() {
        let user = firebase.auth().currentUser;
        console.log(user);
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                // User is signed in.
                this.setState({
                    photoURL: user.photoURL,
                    showWarning: true,
                    displayName: user.displayName,
                    email: user.email,
                    phoneNumber: user.phoneNumber
                })

            }
        });
    }

    connectUser(e) {
        let name = e.target.name;

        if (name == "google") {
            let provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithPopup(provider).then((result) => {
                let token = result.credential.accessToken;
                let user = result.user;
                this.setState({
                    photoURL: user.photoURL,
                    showWarning: true,
                    displayName: user.displayName,
                    email: user.email,
                    phoneNumber: user.phoneNumber
                })
                AvatarStore.setPathImage(user.photoURL);
                console.log(user);

            }).catch(function (error) {
                let errorCode = error.code;
                let errorMessage = error.message;
                let email = error.email;
                let credential = error.credential;
            });
        } else {
            let provider = new firebase.auth.FacebookAuthProvider();
            firebase.auth().signInWithPopup(provider).then((result) => {
                let token = result.credential.accessToken;
                let user = result.user;


                this.setState({
                    photoURL: user.photoURL,
                    showWarning: true,
                    displayName: user.displayName,
                    email: user.email,
                    phoneNumber: user.phoneNumber
                })

                AvatarStore.setPathImage(user.photoURL);
                console.log(user);
            })

        }


    }

    render() {
        return (
            <div className="container mt-45">
                <div className="row">
                    <div className="col-12">

                        <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
                            <div className="card card-signin my-5">
                                <div className="card-body">

                                    {this.state.showWarning &&
                                        <h5 className="card-title text-center">Se déconnecter</h5>}

                                    {!this.state.showWarning &&
                                        <h5 className="card-title text-center">Se connecter</h5>}
                                    {this.state.showWarning &&
                                        <React.Fragment>
                                            <center>
                                                <img src={this.state.photoURL} alt={this.state.displayName} className="img-fluid rounded-circle mb-2" width="128" height="128" />
                                            </center>
                                            <h4 className="card-title mb-0 text-center">{this.state.displayName}</h4>

                                            <div className="text-muted mb-2 text-center">{this.state.email != null ? this.state.email : this.state.phoneNumber}</div>
                                        </React.Fragment>
                                    }
                                    <div className="form-signin">

                                        {
                                            !this.state.showWarning &&
                                            <React.Fragment>
                                                <button className="btn btn-lg btn-google btn-block text-uppercase" onClick={this.connectUser} name="google" type="button"><i className="fab fa-google mr-2"></i> Google</button>
                                                <button className="btn btn-lg btn-facebook btn-block text-uppercase" onClick={this.connectUser} name="facebook" type="button"><i className="fab fa-facebook-f mr-2"></i> Facebook</button>
                                            </React.Fragment>
                                        }
                                        {
                                            this.state.showWarning &&
                                            <button className="btn btn-lg btn-google btn-block text-uppercase" onClick={this.SingOut} name="deconnexion" type="button">Deconnexion</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Profile;


/* <div class="container mt-45">
                <div className="row">
                    <div className="col-12">
                        <div className="card mb-3">
                            <div className="card-body text-center">
                                <img src={this.state.photoURL} alt="Kathy Davis" className="img-fluid rounded-circle mb-2" width="128" height="128" />
                                {this.state.showWarning &&
                                    <React.Fragment>
                                        <h4 className="card-title mb-0">{this.state.displayName}</h4>
                                        <div className="text-muted mb-2">{this.state.email != null ? this.state.email : this.state.phoneNumber}</div>
                                    </React.Fragment>
                                }
                                {this.state.showWarning && <div className="alert alert-success" role="alert">
                                    <h4 className="alert-heading">🏆</h4>
                                    <h4 className="alert-heading">Félicitations !</h4>
                                    <p>Vous avez ajouté avec succès 20 établissements</p>
                                    <hr />
                                    <button type="button" className="btn btn-success">Réclamer votre repas</button>
                                </div>}

                                {
                                    !this.state.showWarning &&
                                    <div>
                                        <h3 className="card-title mb-0"> Connexion </h3>
                                        <br />
                                        <button type="button" onClick={this.connectUser} className="btn" name="google" style={{ backgroundColor: "#d12424", color: "white" }}>Google</button>
                                        <span style={{ visibility: "hidden" }}>
                                            &nbps; &nbps;
                                 </span>
                                        <button type="button" onClick={this.connectUser} className="btn" name="facebook" style={{ backgroundColor: "#007bff", color: "white" }}>facebook</button>
                                    </div>
                                }
                                {
                                    this.state.showWarning &&
                                    <div>
                                        <h3 className="card-title mb-0"> Deconnexion </h3>
                                        <br />
                                        <button type="button" onClick={this.SingOut} className="btn" name="deconnexion" style={{ backgroundColor: "#d12424", color: "white" }}>Deconnexion</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>*/
